// 引入工具函数和路由
import storageClear from "./storageClear";
import router from "../router/index";
import { MessageBox } from 'element-ui';

const timeOut = 60 * 60 * 1000; // 超时时间设为1小时

// 初始化用户操作时间记录
window.addEventListener('load', () => {
    // 设置初始操作时间
    sessionStorage.setItem("lastTime", Date.now().toString());

    // 更新用户操作时间
    document.addEventListener('mousedown', () => {
        sessionStorage.setItem("lastTime", Date.now().toString());
    });

    document.addEventListener('keypress', () => { // 增加键盘事件监听
        sessionStorage.setItem("lastTime", Date.now().toString());
    });
});

function checkTimeout() {
    const currentTime = Date.now();
    const storedTime = parseInt(sessionStorage.getItem("lastTime") || '0', 10);

    if (currentTime - storedTime > timeOut && sessionStorage.getItem('token')) {
        // 清除存储数据
        storageClear.clear();  // 自定义清除函数
        sessionStorage.removeItem('token');  // 明确移除token

        MessageBox.confirm('系统长时间未操作，请重新登录', '提示', {
            confirmButtonText: '重新登录',
            showCancelButton: false,
            type: 'warning',
            closeOnClickModal: false,
            closeOnPressEscape: false
        }).then(() => {
            // 跳转前检查当前路由
            if (router.currentRoute.path !== '/login') {
                router.push({
                    path: '/login',
                });
            }
        }).catch(() => {})
            .finally(() => {
                sessionStorage.removeItem('lastTime'); // 清除计时基准
            });
    }
}

export default function initTimeoutCheck() {
    // 立即执行一次检测
    checkTimeout();

    // 设置周期检测（每30秒）
    const timer = setInterval(checkTimeout, 30000);

    // 提供清理定时器方法（按需调用）
    return () => clearInterval(timer);
}